import { CartStoreFull, CartStoreLite } from './initCarts';
import { useAuthSDK } from '~/features/auth-sdk';
import { ERouteName } from '~/app/router';

const { onInit, onLogout, onAuth } = useAuthSDK();

function isCartPage() {
  const route = useRoute();
  return route.name === ERouteName.CART;
}

export function useHandleCartAuth() {
  onInit(() => {
    /** на cart-page дергаем full-корзину сами */
    if (isCartPage()) return;

    CartStoreLite.fetchCart();
  });

  onAuth(() => {
    /** на cart-page синх+фетч делаем сами */
    if (isCartPage()) return;

    CartStoreLite.syncCart().then(() => CartStoreLite.fetchCart());
  });

  onLogout(() => {
    return isCartPage() ? CartStoreFull.fetchCart() : CartStoreLite.fetchCart();
  });
}
